import { baseUrl } from 'api/helpers'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'

/**
 * Creates a new Ahoy visit and returns the visit token
 * This should be called once per Auth0 session
 */
export const createVisit = async (token) => {
  const visitToken = uuidv4()
  const visitorToken = getOrCreateVisitorToken()

  try {
    await axios.post(
      `${baseUrl}/ahoy/visits`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'Ahoy-Visit': visitToken,
          'Ahoy-Visitor': visitorToken
        }
      }
    )

    // Store visit token in sessionStorage (clears on browser close or logout)
    sessionStorage.setItem('ahoy_visit', visitToken)

    return visitToken
  } catch (error) {
    console.error('Failed to create Ahoy visit:', error)
    throw error
  }
}

/**
 * Tracks an Ahoy event for the current visit
 */
export const trackEvent = async ({ token, name, properties = {} }) => {
  const visitToken = sessionStorage.getItem('ahoy_visit')
  const visitorToken = getOrCreateVisitorToken()

  if (!visitToken) {
    console.warn('No Ahoy visit token found. Call createVisit first.')
    return
  }

  // Ahoy expects an array of events
  const eventData = [{
    name,
    properties,
    time: new Date().toISOString()
  }]

  try {
    await axios.post(
      `${baseUrl}/ahoy/events`,
      eventData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'Ahoy-Visit': visitToken,
          'Ahoy-Visitor': visitorToken
        }
      }
    )
  } catch (error) {
    console.error('Failed to track Ahoy event:', error)
  }
}

/**
 * Gets or creates a visitor token (persists across sessions)
 * Stored in localStorage to track the same visitor across multiple sessions
 */
const getOrCreateVisitorToken = () => {
  let visitorToken = localStorage.getItem('ahoy_visitor')

  if (!visitorToken) {
    visitorToken = uuidv4()
    localStorage.setItem('ahoy_visitor', visitorToken)
  }

  return visitorToken
}

/**
 * Gets the current visit token from sessionStorage
 */
export const getVisitToken = () => {
  return sessionStorage.getItem('ahoy_visit')
}

/**
 * Gets the current visitor token from localStorage
 */
export const getVisitorToken = () => {
  return localStorage.getItem('ahoy_visitor')
}

/**
 * Clears the visit token (call on logout)
 */
export const clearVisit = () => {
  sessionStorage.removeItem('ahoy_visit')
}
